module.exports = __webpack_public_path__ + "assets/img/map-sleeve.cecd4b01.png";